import React from "react";
import LogoModel from "../LogoModel";

const HeaderVolvia = () => (
  <div id="Header">
    <div id="HeaderContainerVolvia"><LogoModel /></div>
  </div>
);

export default HeaderVolvia;
